import {createFileRoute} from '@tanstack/react-router';

import {ChangePasswordPage} from '@/modules/auth/pages/ChangePasswordPage';

export const Route = createFileRoute('/_authenticated/account/password')({
  component: ChangePasswordPage,
});
